import { Input_Base } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Base.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { Html, html } from 'rune-ts';
import {
  ButtonCheckbox,
  InputCheckboxChangeEvent,
} from '@services/MarppleShop/renderApp/components/atoms/ButtonCheckbox/ButtonCheckbox.ts';
import klass from './Input.module.scss';
import { SelectCheckBoxEvent } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/events.ts';

interface InputCheckBoxes extends InputEditor {
  value: {
    id: number;
    label: string | Html;
    active?: boolean;
  }[];
}

export class Input_CheckBoxes extends Input_Base<InputCheckBoxes> {
  private checkBoxViews = this.data.value.map(
    (prop) =>
      new ButtonCheckbox({
        is_mobile: true,
        name: String(prop.id),
        label: prop.label,
        active: prop.active,
      }),
  );

  protected inputTemplate() {
    return html`<div class="${klass.checkbox_wrap}">${this.checkBoxViews}</div>`;
  }

  override onRender() {
    this.addEventListener(InputCheckboxChangeEvent, () => {
      const checkbox_ids = this.checkBoxViews
        .filter((view) => view.isChecked())
        .map((view) => Number(view.getName()));
      this.dispatchEvent(SelectCheckBoxEvent, {
        bubbles: true,
        detail: {
          name: this.getName(),
          checkbox_ids,
        },
      });
    });
  }

  getName(): ValidateField {
    return this.data.name;
  }

  getValue(): unknown {
    return this.data.value;
  }

  setError(): void {
    return void 0;
  }
}
